import { Typography } from '@material-ui/core';

const AppBarTitle = props => <Typography variant="h6" {...props} />;

export default AppBarTitle;
